<template>
    <div class="schedule-container">

        {{ screenWidth }}
        <br>
        {{ screenHeight }}
    </div>
</template>

<script>
export default {
    mounted() {
        let _self = this;
        _self.screenWidth = window.screen.width;
        _self.screenHeight = window.screen.height;
    },
    data() {
        return {
            screenWidth: 0,
            screenHeight: 0,
        };
    },
}
</script>

<style scoped></style>